<div class="dashboard">
    <div class="banner-wrapper">
        <upsc-image-rotator [imageItems]="dashboardBannerConfig.images"
                            [isAutoForward]="dashboardBannerConfig.isAutoForward"
                            [speed]="dashboardBannerConfig.speed"></upsc-image-rotator>

        <upsc-element-blocker *ngIf="isBannersLoading"></upsc-element-blocker>
    </div>

    <upsc-notification-banner *ngIf="appState.customer$()?.IsPastDue && appState.user$()?.CountryCode === 'US'"
                              [type]="'error'">
        <div icon>
            <mat-icon>warning</mat-icon>
        </div>
        <div message>
            <span [innerHtml]="'notifications.message' | translate"></span>
            <a routerLink="/billing-history">
                <span [innerHtml]="'notifications.payNow' | translate"></span>
            </a>
        </div>
    </upsc-notification-banner>

    <div class="dashboard-items-wrapper">
        <div class="main-items">
            <ng-container [ngTemplateOutlet]="announcement"></ng-container>
            <div class="dashboard-items">
                <div *ngIf="appState.userRoutes$()?.ShipUPS"
                     class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="shipUps"></ng-container>
                </div>
                <div *ngIf="appState.userRoutes$()?.ShipFedex"
                     class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="shipFedEx"></ng-container>
                </div>
            </div>
            <div class="dashboard-items">
                <div class="dashboard-item-wrapper"
                     *ngIf="!isEUUser">
                    <ng-container [ngTemplateOutlet]="restrictedZip"></ng-container>
                </div>
                <div class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="packagingChecklist"></ng-container>
                </div>
            </div>
            <ng-container [ngTemplateOutlet]="quickTrack"></ng-container>
            <ng-container [ngTemplateOutlet]="costEstimator"></ng-container>
        </div>

        <div class="side-items">
            <div class="dashboard-items">
                <div *ngIf="isSideBannerAvailable"
                     class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="banner"></ng-container>
                </div>
                <div class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="events"></ng-container>
                </div>
                <div class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="newsItems"></ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showGiftBox"
         class="giftBox">
        <div class="giftIcon"
             id="giftPanel">
            <img alt="UPS"
                 class="ellipse16"
                 src="../../assets/icons/Ellipse 16.svg">
            <img (click)="open_gift()"
                 alt="UPS"
                 class="gift"
                 src="../../assets/icons/gift2.svg">

            <div class="complimentary-scores-container">
                <h1 *ngIf="getComplimentaryScores"
                    (click)="signUp()">Get 50 Complimentary Scores</h1>
                <img (click)="close_gift()"
                     *ngIf="getComplimentaryScores"
                     alt="UPS"
                     class="close"
                     src="../../assets/icons/close.svg">
            </div>
        </div>
    </div>
    <div class="dashboard-footer">
        &copy; {{ getCurrentYear() }} {{ 'siteFooter' | translate }}
    </div>
</div>

<ng-template #header>
    <div class="ups-page-header">
        <h1 class="page-title">Hello, {{ appState.user$()?.FirstName }}!</h1>
    </div>
</ng-template>

<ng-template #announcement>
    <div *ngIf="announcements && announcements.length"
         class="dashboard-item announcement">
        <h4 class="title">{{ announcements[0].Title }}</h4>
        <upsc-truncated-paragraph [characterCountLimit]="dashboardAnnouncementConfig.characterLimit"
                                  [lineCountLimit]="dashboardAnnouncementConfig.lineLimit"
                                  [text]="announcements[0].Content"></upsc-truncated-paragraph>
    </div>
</ng-template>

<ng-template #banner>
    <div class="dashboard-item sidebanner">
        <a [href]="dashboardBannerConfig.images[0].sideDashboardLinkUrl"
           target="_blank">
            <img [src]="dashboardBannerConfig.images[0].sideDashboardImageUrl"
                 alt="Side Banner"/>
        </a>
    </div>
</ng-template>

<ng-template #events>
    <div class="dashboard-item events">
        <h4 class="title"
            [ngClass]="{'lowercase-title': appState.user$()?.CountryCode === 'FR'}">
            <img alt="upcoming events"
                 class="icon"
                 ngSrc="assets/icons/calendar-symbol.svg"
                 height="20"
                 width="20">
            <span>{{ 'dashboard.upcomingEvents'|translate }}</span>
        </h4>
        <upsc-event-list [items]="upcomingEvents"></upsc-event-list>
    </div>
</ng-template>

<ng-template #newsItems>
    <div class="dashboard-item news">
        <h4 class="title">
            <img alt="news"
                 class="icon"
                 src="../../assets/icons/megaphone.svg">
            <span>{{ 'dashboard.news'|translate }}</span>
        </h4>
        <upsc-news-list [items]="news"></upsc-news-list>
    </div>
</ng-template>

<ng-template #trackShipment>
    <div class="dashboard-item track-shipment">
        <h4 class="title">
            <span>{{ 'dashboard.trackShipment'|translate }}</span>
        </h4>
        <h6 class="subtitle">{{ 'dashboard.getPackageStatus'|translate }}</h6>

        <form class="ups-form">
            <div class="form-body">
                <mat-form-field floatLabel="auto">
                    <input matInput
                           placeholder="{{'dashboard.enterTrackingNo'|translate}}">
                </mat-form-field>
            </div>

            <div class="form-footer">
                <div class="form-actions">
                    <button [disabled]="true"
                            color="primary"
                            mat-raised-button
                            type="submit">
                        {{ 'dashboard.Track'|translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #costEstimator>
    <div *ngIf="appState.userRoutes$()?.CostEstimator"
         class="dashboard-item cost-estimator">
        <h4 class="title">
            <img alt="Cost Estimator"
                 class="icon"
                 src="../../assets/icons/calculator.svg">
            <span>{{ 'dashboard.costEstimator'|translate }}</span>
        </h4>
        <p class="center">
            {{ 'dashboard.compareCost'|translate }}<br>
            {{ 'dashboard.competitiveRates'|translate }}
        </p>
        <div class="cost-estimator-actions">
            <button (click)="openCostEstimator($event)"
                    class="alternative-button"
                    mat-raised-button
                    type="button">
                {{ 'GetQuote'|translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #rewardShip>
    <div class="dashboard-item reward-ship">
        <h4 class="title">{{ 'RewardShip'|translate }}</h4>
        <p class="center cta">
            $100.00
        </p>
        <h6 class="subtitle">{{ 'RedeemableCredits'|translate }}</h6>
        <p class="center">
            {{ 'dashboard.payOnTime'|translate }}
        </p>
        <div class="actions">
            <a color="primary"
               mat-raised-button
               routerLink="/rewardship"
               type="button">{{ 'dashboard.viewCredits'|translate }}</a>
        </div>
    </div>
</ng-template>

<ng-template #eInvoice>
    <div class="dashboard-item e-invoice">
        <h4 class="title">{{ 'dashboard.signupEinvoice'|translate }}</h4>
        <h6 class="subtitle">{{ 'emailInvoices'|translate }}</h6>
        <p class="center">
            {{ 'eInvoiceAdvantage'|translate }}
        </p>
        <div class="actions">
        </div>
    </div>
</ng-template>

<ng-template #shipUps>
    <div class="dashboard-item ship-ups">
        @if (customer.DWEnabled && !user.IsGuest) {
            <div class="dw-enabled">
                <h4 class="title">
                    <div class="title-section">
                        <span>{{ 'dashboard.dwEnabled.shipMoreWith' | translate }}</span>
                        <img alt="UPS"
                             class="icon"
                             ngSrc="../../assets/icons/logo-ups.svg"
                             height="30"
                             width="25">
                    </div>
                    <div class="title-section">
                        <span>{{ 'dashboard.dwEnabled.earnMorePoints' | translate }}</span>
                        <img alt="Earn More Points"
                             class="icon"
                             ngSrc="../../assets/icons/travel.svg"
                             height="27"
                             width="27">
                    </div>
                </h4>
                <div class="point-container">
                    <div class="point">
                        @if (isRewardShipPointRetrieving$()) {
                            <mat-spinner [diameter]="27"></mat-spinner>
                        } @else {
                            @if (isRewardShipPointError$()) {
                                <span class="error"
                                      matTooltip="{{ 'dashboard.dwEnabled.pointError' | translate }}">
                                    <span class="material-symbols-outlined">warning</span>
                                </span>
                            } @else {
                                <span>{{ rewardShipPoint$() }}</span>
                            }
                        }
                    </div>
                    <div class="unit"
                         [innerHTML]="'dashboard.dwEnabled.points' | translate"></div>
                    <div class="redeem">
                        <a routerLink="/dw-rewardship">
                            @if (!isRewardShipPointError$() && rewardShipPoint$() > 0) {
                                <span [innerHTML]="'dashboard.dwEnabled.redeem' | translate"></span>
                            } @else {
                                <span [innerHTML]="'dashboard.dwEnabled.view' | translate"></span>
                            }
                        </a>
                    </div>

                    @if (!isRewardShipPointRetrieving$() && !isRewardShipPointError$()) {
                        <div class="value">
                            <span class="fiat-value">{{ rewardShipPoint$() | currency }}</span>
                            <span [innerHTML]="'dashboard.dwEnabled.value' | translate"></span>
                        </div>
                    }
                </div>
                <p class="earn-points">
                    <span [innerHTML]="'dashboard.dwEnabled.earnPoints' | translate"></span>
                    <span class="material-symbols-outlined"
                          matTooltip="{{ 'dashboard.dwEnabled.earnPointsTooltip' | translate }}">info</span>
                </p>
            </div>
        } @else {
            <h4 class="title">
                <span>{{ 'dashboard.shipWith'|translate }}</span>
                <img alt="UPS"
                     class="icon"
                     ngSrc="../../assets/icons/logo-ups.svg"
                     height="30"
                     width="25">
            </h4>
            <p>
                {{ 'dashboard.createUpsShippingLabel'|translate }}
                <span *ngIf="canSeeRewardShip"><br> and earn
            <a routerLink="/dw-rewardship">
                <span>{{ 'dashboard.rewardShip'|translate }}</span>
            </a>
            points
            </span>
            </p>
        }
        <div class="actions">
            <a mat-raised-button
               routerLink="/ship/ups">{{ 'dashboard.createUpsLabel'|translate }}</a>
        </div>
    </div>
</ng-template>

<ng-template #shipFedEx>
    <div class="dashboard-item ship-fedex">
        <h4 class="title">
            <span>{{ 'dashboard.shipWith'|translate }}</span>
            <img alt="FedEx"
                 class="icon"
                 src="../../assets/icons/logo-fedex.svg">
        </h4>
        <p>
            {{ 'dashboard.createFedexShippingLabel'|translate }}
        </p>
        <div class="actions">
            <a mat-raised-button
               routerLink="/ship/fedex">{{ 'dashboard.createFedexLabel'|translate }}</a>
        </div>
    </div>
</ng-template>

<ng-template #restrictedZip>
    <div class="dashboard-item restricted-zip">
        <a routerLink="/support/restricted-zip-codes" class="no-underline">
            <span>{{ 'dashboard.viewRestrictedZipCodes'|translate }}</span>
            <mat-icon>arrow_forward</mat-icon>
        </a>
    </div>
</ng-template>

<ng-template #packagingChecklist>
    <div class="dashboard-item packaging-checklist">
        <a (click)="downloadPackagingChecklist($event)"
           class="no-underline"
           href="#">
            <mat-icon>check</mat-icon>
            <span>{{ 'dashboard.safePackagingChecklist'|translate }}</span>
        </a>
        <upsc-s3-file-downloader #packagingChecklistDownloader
                                 (fileDownloadEnded)="onPackagingChecklistDownloadEnded($event)"
                                 [bucketName]="'members-pdf.upsc'"
                                 [fileName]="(storageService.getAsText('lang') === 'de') ? 'German Safe Shipping and Packaging Checklist.pdf' : 'packaging_checklist.pdf'"
                                 [hidden]="true"></upsc-s3-file-downloader>
        <upsc-element-blocker *ngIf="isPackagingChecklistDownloading"></upsc-element-blocker>
    </div>
</ng-template>

<ng-template #quickTrack>
    <div [hidden]="!appState.userRoutes$()?.ShipmentHistory"
         class="dashboard-item quick-track">
        <h4 [ngClass]="{'lowercase-title': appState.user$()?.CountryCode === 'FR'}"
            class="title">
            <img alt="Quick Track"
                 class="icon"
                 ngSrc="assets/icons/location.svg"
                 height="24"
                 width="16">
            <span>{{ 'dashboard.quickTrack'|translate }}</span>
        </h4>

        @if (appState.user$()?.CountryCode === "US") {
            <a class="see-all-tracks"
               routerLink="/track-shipments">{{ 'dashboard.seeAll'|translate }}</a>
        } @else {
            <a class="see-all-tracks"
               routerLink="/shipment-history">{{ 'dashboard.seeAll'|translate }}</a>
        }

        <table [dtOptions]="dtOptions"
               [dtTrigger]="dtTrigger"
               class="row-border compact"
               datatable>
            <thead>
            <tr>
                <th width="*">{{ 'Recipient'|translate }}</th>
                <th width="33.3333333%">{{ 'TrackingNumber'|translate }}</th>
                <th class="text-center"
                    width="33.3333333%">{{ 'Status'|translate }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let shipment of quickTrackShipments">
                <td class="recipient text-ellipsis">
                        <span [matTooltipPosition]="'right'"
                              matTooltip="{{ getShipmentRecipient(shipment) }}">{{
                                getShipmentRecipient(shipment) }}</span>
                </td>
                <td class="tracking-number">
                    <a (click)="openTrackedShipmentDialog($event, shipment)"
                       href="#">{{ shipment.TrackingNumber
                        }}</a>
                </td>
                <td class="text-center status">{{ shipment.LastScanDescription }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</ng-template>
